<template>
  <div
    class="multiselect-container"
    :class="{ active: isActive }"
    @blur="handleBlur"
  >
    <div class="multiselect-input" @click="toggleDropdown">
      <input type="hidden" />
      <div class="selections">
        <div v-if="selectedValues.length == 0" class="placeholder">
          {{ placeholder }}
        </div>
        <div
          v-else
          class="value"
          v-for="(value, index) in selectedValues"
          :key="index"
        >
          {{ value.name }}
        </div>
      </div>
      <span class="dropdown-icon"><i class="fas fa-angle-down"></i></span>
    </div>
    <div class="multiselect-dropdown">
      <!-- <input
        v-model="searchQuery"
        class="search-input"
        type="text"
        placeholder="搜索"
        @click.stop
        @keydown.enter.stop.prevent="search()"
      /> -->
      <ul class="options">
        <li v-for="(option, index) in filteredOptions" :key="index">
          <input
            type="checkbox"
            :value="option"
            :checked="isSelected(option)"
            @change="toggleSelection(option)"
          />
          <label>{{ option.name }}</label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Multiselect",
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
  },
  data() {
    return {
      isActive: false,
      searchQuery: "",
      selectedValues: this.value || [],
    };
  },
  watch: {
    value(newValue) {
      this.selectedValues = newValue;
    },
  },
  computed: {
    filteredOptions() {
      return this.options.filter((option) =>
        option.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  created() {},
  methods: {
    toggleDropdown() {
      this.isActive = !this.isActive;
    },
    isSelected(option) {
      return this.selectedValues.includes(option);
    },
    toggleSelection(option) {
      if (this.isSelected(option)) {
        const index = this.selectedValues.indexOf(option);
        if (index > -1) {
          this.selectedValues.splice(index, 1);
        }
      } else {
        this.selectedValues.push(option);
      }
      this.$emit("input", this.selectedValues);
    },

    //搜索
    search() {
      this.$emit("search", this.searchQuery);
    },

    //失焦
    handleBlur() {
      this.isActive = false;
    },
  },
};
</script>

<style>
.multiselect-container {
  position: relative;
  font-size: 16px;
  color: #333;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
}

.multiselect-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 12px;
  border: 1px solid var(--secondary-color);
  border-radius: 4px;
  cursor: pointer;
  height: 100%;
}
.multiselect-container.active .multiselect-input,
.multiselect-container .multiselect-input:hover {
  border-width: 2px;
}
.selections {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}

.placeholder {
  color: #666;
  font-size: 13px;
}

.value {
  display: flex;
  align-items: center;
  margin-right: 6px;
  padding: 2px 6px;
  border-radius: 3px;
  background-color: #eee;
}

.dropdown-icon {
  margin-left: 8px;
}

.multiselect-dropdown {
  /* position: absolute; */
  top: 100%;
  left: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  z-index: 999;
  padding: 8px;
  max-height: 200px;
  overflow-y: auto;
  opacity: 0;
  /* visibility: hidden; */
  display: none;
  transition: all 0.3s ease;
}

.multiselect-container.active .multiselect-dropdown {
  opacity: 1;
  /* visibility: visible; */
  display: block;
  margin-top: 4px;
}

.search-input {
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 6px 8px;
  width: 100%;
  margin-bottom: 8px;
}

.options {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 150px;
  overflow-y: auto;
}

.options li {
  margin-bottom: 8px;
  cursor: pointer;
}

.options li input[type="checkbox"] {
  margin-right: 6px;
}
</style>